<template>
  <div>
    <div style="background-color: #f6f8f9">
      <div class="step-container">
        <el-row type="flex" justify="space-around">
          <el-col :lg="14" :sm="24" :xs="24">
            <el-card class="box-card">
              <step-bar
                  :steps="steps"
                  :common-image="stepIcon"
                  :disabled="visibleLoad"
                  @step-click="handleStepClick"
              />
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- ========== 数据加载完成后才渲染内容区域 ========== -->
    <div v-if="isReady" class="content-container">
      <personal-basic-info
          v-show="active === 0"
          ref="personalBasicInfo"
          :form="form"
          :is-post="isPost"
          :is-view="isView"
          :is-profession-tech="isProfessionTech"
          :is-required="isRequired"
          :is-technique="isTechnique"
          @nextActice="next"
          @onLoad="onLoadBasicInfo"
      />
      <personal-dgree-info
          v-show="active === 1"
          ref="personalDgreeInfo"
          :form="form"
          :is-post="isPost"
          :is-view="isView"
          :is-profession-tech="isProfessionTech"
          :is-required="isRequired"
          :is-technique="isTechnique"
          :pro-edu-catalog="proEduCatalog"
          :study-catalog="studyCatalog"
          :one-level-study="oneLevelStudy"
          :pro-one-level-study="proOneLevelStudy"
          @nextActice="next"
          @preActive="preStep"
      >
      </personal-dgree-info>
      <personal-experience
          v-show="active === 2"
          ref="personalExperience"
          :form="form"
          :is-post="isPost"
          :is-view="isView"
          :is-profession-tech="isProfessionTech"
          :is-required="isRequired"
          :is-technique="isTechnique"
          @nextActice="next"
          @preActive="preStep"
      ></personal-experience>
      <personal-education-info
          v-show="active === 3"
          ref="personalEducation"
          :form="form"
          :is-post="isPost"
          :is-view="isView"
          :is-profession-tech="isProfessionTech"
          :is-required="isRequired"
          :is-technique="isTechnique"
          :position-info-id="positionInfoId"
          :research-orientations="researchOrientations"
          @preActive="preStep"
          @addRow="addRow"
          @childDataChecks="childDataChecks"
      ></personal-education-info>
    </div>

    <!-- ========== 加载中提示 ========== -->
    <div v-else class="loading-container">
      <el-spinner size="large" text="数据加载中..." />
    </div>
  </div>
</template>

<script>
import {
  getAllResumeInfoByPositionIdAndUserPhone,
  getResumeInfoById,
  getResumeInfoByUserPhone,
} from "@/api/recruit/user/resume";
import personalBasicInfo from "@/views/recruit/applicant/personalBasicInfo.vue";
import personalEducationInfo from "@/views/recruit/applicant/personalEducationInfo.vue";
import personalExperience from "@/views/recruit/applicant/personalExperience.vue";
import personalDgreeInfo from "@/views/recruit/applicant/personalDgreeInfo.vue";
import settingHelp from "@/config/localSetting";
import { mapGetters } from "vuex";
import stepBar from "^/zr/dialog/stepBar.vue";
import { getBasicData } from "@/api/job/postInfo";
import { findDataTreeByTypeCode } from "@api/framework/basicData/dataDictType";

const config = settingHelp.getConfig();
const { remoteURL } = config;

export default {
  name: "PersonalResumeNew",
  components: {
    personalBasicInfo,
    personalEducationInfo,
    personalExperience,
    personalDgreeInfo,
    stepBar,
  },
  data() {
    return {
      active: 0,
      form: {
        name: "",
        sex: "",
        fileList: [],
        fileList1: [],
        experienceList: [],
        degreeList: [],
        education: {},
        familyInfo: [],
        parcticeLiveList: [],
        workLiveList: [],
        projectLiveList: [],
        languageInfoList: [],
        topDegree: "",
        topDegreeName: "",
        hasFamily: "是",
        hasPractice: "是",
        hasWorkLive: "是",
        hasProjectLive: "是",
        yardRelations: "",
        deptRelation: ""
      },
      stepIcon: require("@/assets/zr/images/resume_way.png"),
      pictureUploadAction: "",
      postSendId: "",
      positionInfoId: "",
      researchOrientations: "",
      isTechnique: false,
      isProfessionTech: false,
      firstSave: false,
      imageUrl: "",
      isView: false,
      isPost: false,
      isRequired: true,
      loading: true,
      loginUser: {},
      unSuit: false,
      collected: false,
      visibleLoad: true,
      proEduCatalog: [],
      studyCatalog: [],
      oneLevelStudy: [],
      proOneLevelStudy: [],

      // ========== 新增：数据是否已完全加载 ==========
      isReady: false,
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
    }),
    steps() {
      return [
        {
          label: "基本情况",
          component: "StepOne",
          disabled: this.visibleLoad,
          completed: 0 <= this.active,
          isCurrent: 0 === this.active,
        },
        {
          label: "教育背景",
          component: "StepTwo",
          disabled: this.visibleLoad,
          completed: 1 <= this.active,
          isCurrent: 1 === this.active,
        },
        {
          label: "工作经历",
          component: "StepThree",
          disabled: this.visibleLoad,
          completed: 2 <= this.active,
          isCurrent: 2 === this.active,
        },
        {
          label: "其他信息",
          component: "StepFour",
          disabled: this.visibleLoad,
          completed: 3 <= this.active,
          isCurrent: 3 === this.active,
        },
      ];
    },
  },
  async mounted() {
    this.visibleLoad = true;
    await this.getResumeInfo();
  },
  methods: {
    addRow(row) {
      this.form.languageInfoList.push(row);
    },

    handleStepClick(index) {
      if (this.steps[index].disabled) {
        return;
      }
      if (this.active === 0) {
        if (!this.$refs.personalBasicInfo.childDataCheck()) {
          return;
        }
      }
      if (this.active === 1) {
        if (!this.$refs.personalDgreeInfo.childDataCheck()) {
          return;
        }
      }
      if (this.active === 2) {
        if (!this.$refs.personalExperience.childDataCheck()) {
          return;
        }
      }
      this.active = index;
      window.scrollTo(0, 0);
    },

    next() {
      if (this.active++ > 3) this.active = 0;
      window.scrollTo(0, 0);
    },

    preStep() {
      if (this.active >= 1) {
        this.active--;
        window.scrollTo(0, 0);
      }
    },

    onLoadBasicInfo(visible) {
      this.visibleLoad = visible;
      if (!this.isTechnique && !this.isProfessionTech) {
        this.visibleLoad = true;
      }
      if (this.firstSave) {
        this.visibleLoad = true;
      }
    },

    // 查询简历信息
    async getResumeInfo() {
      try {
        // 管理员查看简历
        if (this.$route.query.postSendId) {
          this.isView = true;
          this.isRequired = false;

          let res = await getResumeInfoById({
            postSendId: this.$route.query.postSendId,
          });

          if (res.success) {
            this.postSendId = res.data.postSendId;
            this.unSuit = res.data.unSuit;
            this.collected = res.data.collected;
            await this.dataToForm(res.data);
          } else {
            this.$message.error(res.message);
          }
        }
        // 投递简历时
        else if (this.$route.query.isPost && this.$route.query.positionInfoId) {
          this.isPost = true;
          this.researchOrientations = this.$route.query.researchOrientations;
          this.loginUser = { name: this.userName, id: this.userPhone };
          this.positionInfoId = this.$route.query.positionInfoId;

          let res = await getAllResumeInfoByPositionIdAndUserPhone({
            positionInfoId: this.$route.query.positionInfoId,
            userPhone: this.userPhone,
          });

          if (res.success) {
            await this.dataToForm(res.data);
          } else {
            this.$message.error(res.message);
          }
        }
        // 直接点击我的简历
        else {
          this.loginUser = { name: this.userName, id: this.userPhone };

          let res = await getResumeInfoByUserPhone({
            userPhone: this.userPhone,
          });

          if (res.success) {
            await this.dataToForm(res.data);
          } else {
            this.$message.error(res.message);
          }
        }
      } finally {
        this.loading = false;
      }
    },

    // 表单数据回填
    async dataToForm(data) {
      this.pictureUploadAction =
          remoteURL + "/comm/file/uploadPicture?resumeId=" + data.formData.id;

      if (data.postSendId) this.postSendId = data.postSendId;
      if (data.isProfessionTech) this.isProfessionTech = data.isProfessionTech;
      if (data.isTechnique) this.isTechnique = data.isTechnique;
      if (data.firstSave) this.firstSave = data.firstSave;

      if (!data.formData.education) data.formData.education = {};
      this.form = { ...this.form, ...data.formData };

      if (
          data.formData.experienceList &&
          data.formData.experienceList.length &&
          data.formData.experienceList.length > 0
      ) {
        this.form.topDegree =
            data.formData.experienceList[
            data.formData.experienceList.length - 1
                ].phase;
        this.form.experienceList.forEach((item) => {
          if (item.university && item.university === "其他") {
            item.isShowOtherSchool = true;
          } else {
            item.isShowOtherSchool = false;
          }
        });
      }

      if (
          data.formData.degreeList &&
          data.formData.degreeList.length &&
          data.formData.degreeList.length > 0
      ) {
        this.form.topDegreeName =
            data.formData.degreeList[
            data.formData.degreeList.length - 1
                ].degreeName;
        this.form.degreeList.forEach((item) => {
          if (item.degreeDept && item.degreeDept === "其他") {
            item.isShowOtherDept = true;
          } else {
            item.isShowOtherDept = false;
          }
        });
      } else {
        this.form.topDegreeName = "无";
      }

      if (
          data.formData.familyInfo &&
          data.formData.familyInfo.length &&
          data.formData.familyInfo.length > 0
      ) {
        this.form.hasFamily = "是";
      } else {
        this.form.hasFamily = "否";
      }

      if (
          data.formData.parcticeLiveList &&
          data.formData.parcticeLiveList.length &&
          data.formData.parcticeLiveList.length > 0
      ) {
        this.form.hasPractice = "是";
      } else {
        this.form.hasPractice = "否";
      }

      if (
          data.formData.workLiveList &&
          data.formData.workLiveList.length &&
          data.formData.workLiveList.length > 0
      ) {
        this.form.hasWorkLive = "是";
      } else {
        this.form.hasWorkLive = "否";
      }

      if (
          data.formData.projectLiveList &&
          data.formData.projectLiveList.length &&
          data.formData.projectLiveList.length > 0
      ) {
        this.form.hasProjectLive = "是";
      } else {
        this.form.hasProjectLive = "否";
      }

      // ========== 处理级联选择器的路径 ==========
      if (this.form.placeOfOrigin && this.form.placeOfOrigin.length > 0) {
        this.form.placeOfOrigin = this.form.placeOfOrigin.split(",");
        if (this.form.placeOfOrigin.length === 1) {
          if (
              !(
                  this.form.placeOfOrigin[0] === "新疆建设兵团" ||
                  this.form.placeOfOrigin[0] === "澳门特别行政区" ||
                  this.form.placeOfOrigin[0] === "香港特别行政区" ||
                  this.form.placeOfOrigin[0] === "台湾省"
              )
          ) {
            this.form.placeOfOrigin = [];
          }
        }
      }

      if (this.form.nativePlace && this.form.nativePlace.length > 0) {
        this.form.nativePlace = this.form.nativePlace.split(",");
        if (this.form.nativePlace.length === 1) {
          if (
              !(
                  this.form.nativePlace[0] === "新疆建设兵团" ||
                  this.form.nativePlace[0] === "澳门特别行政区" ||
                  this.form.nativePlace[0] === "香港特别行政区" ||
                  this.form.nativePlace[0] === "台湾省"
              )
          ) {
            this.form.nativePlace = [];
          }
        }
      }

      if (this.form.birthdayLocal && this.form.birthdayLocal.length > 0) {
        this.form.birthdayLocal = this.form.birthdayLocal.split(",");
        if (this.form.birthdayLocal.length === 1) {
          if (
              !(
                  this.form.birthdayLocal[0] === "新疆建设兵团" ||
                  this.form.birthdayLocal[0] === "澳门特别行政区" ||
                  this.form.birthdayLocal[0] === "香港特别行政区" ||
                  this.form.birthdayLocal[0] === "台湾省"
              )
          ) {
            this.form.birthdayLocal = [];
          }
        }
      }
      if(!this.form.yardRelations||this.form.yardRelations===""){
        this.form.yardRelations="否"
      }
      if(!data.deptRelation||data.deptRelation===""){
        this.form.deptRelation="否"
      }else {
        this.form.deptRelation=data.deptRelation
      }
      // ========== 加载其他数据 ==========
      await this.getOneLevelStudy();
      await this.getProEduCatalog();
      await this.getProOneLevelStudy();
      await this.getStudyCatalog();

      // ========== 所有数据加载完成 ==========
      this.isReady = true;
    },

    async getProEduCatalog() {
      // let res = await getBasicData({ typeCode: "profession_edu_catalog" });
      // if (res.success) {
      //   this.proEduCatalog = this.bulidTreeData(res.data);
      let res = await findDataTreeByTypeCode({ typeCode: "profession_edu_catalog" });
      if (res.success) {
        this.proEduCatalog = res.data;
      } else {
        this.$message.error(res.message);
      }
    },

    async getStudyCatalog() {
      // let res = await getBasicData({ typeCode: "studyFieldCategory" });
      // if (res.success) {
      //   this.studyCatalog = this.bulidTreeData(res.data);
      let res = await findDataTreeByTypeCode({ typeCode: "studyFieldCategory" });
      if (res.success) {
        this.studyCatalog = res.data;
      } else {
        this.$message.error(res.message);
      }
    },

    async getOneLevelStudy() {
      let res = await getBasicData({ typeCode: "oneLevelStudy" });
      if (res.success) {
        this.oneLevelStudy =this.bulidTreeData(res.data);
      } else {
        this.$message.error(res.message);
      }
    },

    async getProOneLevelStudy() {
      let res = await getBasicData({ typeCode: "proOneLevelStudy" });
      if (res.success) {
        this.proOneLevelStudy =this.bulidTreeData(res.data);
      } else {
        this.$message.error(res.message);
      }
    },

    bulidTreeData(data, rootParentId = "") {
      const tree = [];
      data.forEach((item) => {
        if (item.parentId === rootParentId) {
          const children = this.bulidTreeData(data, item.id);
          if (children.length && children.length > 0) {
            item.children = children;
          }
          tree.push(item);
        }
      });
      return tree;
    },

    childDataChecks(callback) {
      if (!this.$refs.personalDgreeInfo?.childDataCheck()) {
        callback("1");
      } else if (!this.$refs.personalExperience?.childDataCheck()) {
        callback("2");
      } else callback("0");
    },
  },
};
</script>

<style scoped>
.step-container {
  background-color: #f6f8f9;
  border-color: #f6f8f9;
  padding: 20px;
  border-radius: 4px;
}

.step-container .el-step {
  margin-right: 20px !important;
}

.content-container {
  background: #fff;
}

.loading-container {
  background: #fff;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-step.is-clickable {
  cursor: pointer;
}

.el-step:hover {
  color: #409eff;
}

el-step:hover::after {
  background-color: #409eff;
}

.el-step.is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
